"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomListCreateRoomMessage = void 0;
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.RoomListCreateRoomMessage = message_1.createMessage('room-list/create-room', joi_1.default.object())
    .withResponse();
